<script>
    import { Pie } from 'vue-chartjs'
    import reactiveChart from './reactiveChart.mixin';

    export default {
        extends: Pie,
        mixins: [ reactiveChart ]
    }
</script>


// WEBPACK FOOTER //
// src/components/stats/charts/common/pie.chart.vue